import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid, FormLabel, FormControlLabel, Switch, FormHelperText } from '@mui/material';

import { fields, initialValues, schema, resources, actions } from './config';

import { FieldArray, useFormikContext } from 'formik';

import { BasicFlex } from '../../utils/Common';

import Field from '../../utils/FormikFields/Field';

import { useQuery } from '@tanstack/react-query';

// apiService
import RoleService from '../Roles/apiService';

import ErrorMessage from '../../utils/MuiFields/ErrorMessage';

const SwitchField = ({ resource, action, push, remove }) => {
  const { values } = useFormikContext();

  console.log(resource, "resource!!", values);

  return (
    <Switch
      size='small'
      checked={values?.permissions?.find(permission => permission.subject === resource && permission.action === action)}
      onChange={(e) => {
        if (e.target.checked) {
          push({  action, subject: resource });
        } else {
          remove(values?.permissions?.findIndex(permission => permission.subject === resource && permission.action === action));
        }
      }}
    />
  );
}

const EditRole = () => {
  return (
    <EditForm title={"Role"} initialValues={initialValues} fields={fields} schema={schema} url={"roles"} validateOnChange={false}>
        <FieldArray name="permissions">
          {({ insert, remove, push }) => {
           return Object.keys(resources).map((resource, index) => (
            <Grid size={3} key={resource}>
              <FormLabel sx={{display: "block",marginBottom: "1.5rem", fontWeight: "500"}}>{resources[resource]}</FormLabel>
              {Object.keys(actions).map(action => { 
                let { label, value } = actions[action]
                return (<BasicFlex key={`${resource}-${action}`} my="1rem" width="15rem">
                  <span>{label}</span>
                  <SwitchField resource={resource} action={value} push={push} remove={remove} />
                </BasicFlex>)
                }
              )}
              {resource === "all" && <ErrorMessage error message="This role will override and grant access to all resources, be very careful!" />}
            </Grid>
           )
          )}
          }
        </FieldArray>
        
    </EditForm>
  );
}

export default EditRole;